import React from 'react';
import { Modal, Card, Calendar, List, Button, Space, Table, Spin, Typography, Input, message } from 'antd';
import {
    LeftOutlined,
    LaptopOutlined,
    CalendarOutlined,
    ReadOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import HoverIcon from '../icons/HoverIcon';

const DemoRequests = ({
    isRescheduleModalOpen,
    setIsRescheduleModalOpen,
    rescheduleDate,
    setRescheduleDate,
    rescheduleTime,
    setRescheduleTime,
    timezoneAdjustedData,
    timezoneAdjustedUnavailable,
    isPast,
    getFormattedDate,
    setRescheduleLoading,
    convertTime,
    selectedTimezone,
    meetingIdToReschedule,
    axiosInstance,
    message,
    fetchDemoRequests,
    getDate,
    noteLoading,
    noteList,
    isReadNotesModalOpen,
    setIsReadNotesModalOpen,
    chatContainerRef,
    noteInput,
    setNoteInput,
    handleNoteSubmit,
    handleOpenNoteModal,
    demoRequests,
    loading,
    setSelectedRecord,
    setMeetingIdToReschedule,
    renderGroupedNotes
}) => {
    const dateCellRender = (value) => {
        return timezoneAdjustedData[value.format("YYYY-MM-DD")] ? null : <div style={{ color: "#bbb" }}></div>;
    };
    return (

        <div>
            <Modal
                title="Reschedule Meeting"
                open={isRescheduleModalOpen}
                onCancel={() => setIsRescheduleModalOpen(false)}
                footer={null}
                width={500}
            >
                {!rescheduleDate ? (
                    <Card className="mb-10px glass-card">
                        <Calendar
                            fullscreen={false}
                            defaultValue={dayjs()}
                            onSelect={(value) => setRescheduleDate(value.format("YYYY-MM-DD"))}
                            dateCellRender={dateCellRender}
                            disabledDate={(date) => !timezoneAdjustedData[date.format("YYYY-MM-DD")]}
                        />
                    </Card>
                ) : !rescheduleTime ? (
                    <div>
                        <h3 className="text-center text-lg font-medium mb-2">Select Time</h3>
                        <div className="flex justify-between mb-4 items-center">
                            <div onClick={() => setRescheduleDate(null)} > <LeftOutlined /> </div>
                            <div className="mb-2 text-sm text-gray-400 text-center">
                                {getFormattedDate(rescheduleDate)} | 30 minutes
                            </div>
                            <div>

                            </div>
                        </div>
                        <List
                            style={{ maxHeight: "400px", overflowY: "auto" }}
                            dataSource={timezoneAdjustedData[rescheduleDate]}
                            renderItem={(time) => (
                                <List.Item>
                                    <Button
                                        block
                                        type="primary"
                                        style={{
                                            backgroundColor:
                                                timezoneAdjustedUnavailable[rescheduleDate]?.includes(time) || isPast(rescheduleDate, time)
                                                    ? "transparent"
                                                    : "#2563EB",
                                            borderColor: "#2563EB",
                                            color:
                                                timezoneAdjustedUnavailable[rescheduleDate]?.includes(time) || isPast(rescheduleDate, time)
                                                    ? "#000000"
                                                    : "#ffffff"
                                        }}
                                        disabled={
                                            timezoneAdjustedUnavailable[rescheduleDate]?.includes(time) || isPast(rescheduleDate, time)
                                        }
                                        onClick={() => setRescheduleTime(time)}
                                    >
                                        {timezoneAdjustedUnavailable[rescheduleDate]?.includes(time)
                                            ? `Not Available ${time}`
                                            : `Book ${time}`}
                                    </Button>
                                </List.Item>
                            )}
                        />
                    </div>
                ) : (
                    <div>
                        <h3 className="text-center text-lg font-medium mb-2 mt-8">Confirm Reschedule</h3>
                        <div className="flex justify-between items-center mb-4">
                            <div onClick={() => setRescheduleTime(null)} > <LeftOutlined /> </div>
                            <div className="text-center text-gray-600 mb-4">
                                {getFormattedDate(rescheduleDate)} | {rescheduleTime} - 30 minutes
                            </div>
                            <div>

                            </div>
                        </div>
                        <Button
                            type="primary"
                            block
                            onClick={async () => {
                                try {
                                    setRescheduleLoading(true);
                                    const { adjustedDate, adjustedTime } = convertTime(
                                        rescheduleTime,
                                        rescheduleDate,
                                        "Asia/Kolkata",
                                        selectedTimezone
                                    );
                                    const payload = {
                                        meeting_id: meetingIdToReschedule,
                                        new_date_time: `${adjustedDate}T${adjustedTime}`,
                                    };
                                    await axiosInstance.post(`/demo/reschedule/`, payload);
                                    message.success("Meeting Rescheduled");
                                    setIsRescheduleModalOpen(false);
                                    fetchDemoRequests();
                                    getDate()
                                    setRescheduleDate(null);
                                    setRescheduleTime(null);
                                } catch (error) {
                                    message.error(error?.response?.data?.error || "Reschedule failed");
                                } finally {
                                    setRescheduleLoading(false);
                                }
                            }}
                        >
                            Confirm Reschedule
                        </Button>
                    </div>
                )}
            </Modal>

            {/* read detail model  */}
            {isReadNotesModalOpen && (
                <>
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            height: "100vh",
                            width: "100vw",
                            backgroundColor: "rgba(0, 0, 50, 0.3)", // bluish-gray transparent
                            zIndex: 9998, // less than note box
                        }}
                        onClick={() => setIsReadNotesModalOpen(false)} // Click on backdrop = close
                    />

                    <div
                        style={{
                            position: "fixed",
                            top: "50%",
                            right: "0px",
                            transform: "translateY(-50%)",
                            width: "400px",
                            height: "80vh", // Adjust height as needed
                            maxHeight: "80vh",
                            borderRadius: "8px 0 0 8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            zIndex: 9999,
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                        }}
                        className="dark:bg-[#100F38] bg-[#FFFFFF] dark:border border-[#3939bb]"
                    >
                        {/* Header */}
                        <div
                            className="bg-[#f7f7f7] dark:bg-[#100F38] py-[10px] px-[16px] border-b border-[#f0f0f0] flex justify-between items-center font-bold"

                        >
                            Meeting Notes
                            <Button size="small" onClick={() => setIsReadNotesModalOpen(false)}>
                                Close
                            </Button>
                        </div>

                        {/* Chat Scroll Box */}
                        <div
                            ref={chatContainerRef}
                            style={{
                                flex: 1,
                                overflowY: "auto",
                                padding: "10px",
                                width: "400px",
                            }}
                        >
                            {noteLoading ? (
                                <Spin />
                            ) : noteList.length === 0 ? (
                                <Typography.Text>No notes yet.</Typography.Text>
                            ) : (
                                renderGroupedNotes()
                            )}
                        </div>

                        {/* Input Footer */}
                        <div style={{ padding: "10px", borderTop: "1px solid #f0f0f0" }}>
                            <Input.TextArea
                                rows={2}
                                placeholder="Write your note here..."
                                value={noteInput}
                                onChange={(e) => setNoteInput(e.target.value)}
                                style={{ marginBottom: 8 }}
                            />
                            <div className="flex justify-end">

                                <Button
                                    type="primary"

                                    loading={noteLoading}
                                    onClick={handleNoteSubmit}
                                >
                                    Add Note
                                </Button>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <div className="text-black pb-3 px-2 flex items-center justify-between">
                <h1 className="mt-1 text-3xl font-bold font-inter dark:text-white">Demo Requests</h1>
            </div>
            <Table
                dataSource={demoRequests}
                columns={[
                    {
                        title: "First Name",
                        dataIndex: "first_name",
                        key: "first_name",
                    },
                    {
                        title: "Last Name",
                        dataIndex: "last_name",
                        key: "last_name",
                    },
                    {
                        title: "Email",
                        dataIndex: "email",
                        key: "email",
                    },
                    {
                        title: "Contact No",
                        dataIndex: "contact_no",
                        key: "request_reason",
                    },
                    {
                        title: "Entity Name",
                        dataIndex: "entity_name",
                        key: "request_response_by",
                    },
                    {
                        title: "Request Date & Time",
                        dataIndex: "request_date",
                        key: "request_date",
                        render: (text) => new Date(text).toLocaleString(), // Format date
                    },
                    {
                        title: "Action",
                        key: "action",
                        render: (_, record) => (
                            <Space>
                                <HoverIcon
                                    icon={
                                        <LaptopOutlined
                                            className="!text-[#4E36A3]"   // 👈 Tailwind force override
                                        />
                                    }
                                    tooltip="Goto Meet"
                                    hoverBgColor={record.status === "cancelled" ? "transparent" : "#4E36A3"}
                                    hoverColor={record.status === "cancelled" ? "gray" : "white"}
                                    onClick={() => window.open(record?.meeting?.meet_link)}
                                    disabled={record.status === "cancelled" || (loading.status && loading.id === record.id)}
                                />
                                <HoverIcon
                                    icon={
                                        <CalendarOutlined
                                            className="!text-[#AF3A94]"  // 👈 fixed pink/purple
                                        />
                                    }
                                    tooltip="Reschedule Meet"
                                    hoverBgColor={record.status === "cancelled" ? "transparent" : "#AF3A94"}
                                    hoverColor={record.status === "cancelled" ? "gray" : "white"}
                                    onClick={() => {
                                        setSelectedRecord(record);
                                        setIsRescheduleModalOpen(true);
                                        setMeetingIdToReschedule(record?.meeting?.id);
                                    }}
                                    disabled={record.status === "cancelled"}
                                />
                                <HoverIcon
                                    icon={
                                        <ReadOutlined
                                            className="!text-red-500"   // 👈 fixed red
                                        />
                                    }
                                    tooltip="View / Add Note"
                                    hoverBgColor={record.status === "cancelled" ? "transparent" : "red"}
                                    hoverColor={record.status === "cancelled" ? "gray" : "white"}
                                    onClick={() => handleOpenNoteModal(record)}
                                    disabled={record.status === "cancelled"}
                                />
                            </Space>
                        ),
                    }
                    ,
                ]}
                size="small"
                rowKey={(record) => record.id} // Ensure unique keys for rows
                pagination={{ pageSize: 10 }}
                className="overflow-y-scroll text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]"
            />
        </div>
    )
}

export default DemoRequests
